const stationWidList = [
    'BALAMT',
    'BOSSST',
    'CHIUST',
    'DCAUST',
    'LAXUST',
    'NWKPNS',
    'NYCPAS',
    'NYCPEN',
    'PHLTTH',
    'SANAMT2',
    'ATLGLI',
    'CHIGLI3',
    'HGOUSCOR',
    'HOUGLI',
    'MENGPS',
    'NHVUSFLX',
    'NYCGOB2',
    'NYCUSOUR7',
    'ORLGLI',
    'PHXAMT',
    'SEAAMT',
];

const locale = 'en-us';

const parsedDataObjects = stationWidList.map(s2sIdentifier => {
    /* eslint-disable global-require */
    const content = require(`./${locale}/${s2sIdentifier}-content.json`);
    const factoids = require(`./${locale}/${s2sIdentifier}-factoids.json`);
    const images = require(`./${locale}/${s2sIdentifier}-images.json`);
    /* eslint-enable global-require */

    return {
        [`${s2sIdentifier}content`]: content,
        [`${s2sIdentifier}factoids`]: factoids,
        [`${s2sIdentifier}images`]: images,
    };
});

const mergedDataObjects = parsedDataObjects.reduce(
    (previousValue, currentValue) => Object.assign({}, previousValue, currentValue),
    {},
);

const content = {
    [locale]: mergedDataObjects,
};

const getContent = () => content;

export default getContent;
